module.exports = __webpack_public_path__ + "media/sub3-4.60931f97.mp4";